import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FiBarChart,
  FiTarget,
  FiFileText,
  FiCheckCircle,
  FiTrendingUp,
  FiClipboard,
  FiShield,
  FiArrowRight
} from 'react-icons/fi';
import RmbIcon from '../RmbIcon';
import './Services.css';

const Services = () => {
  const [activeService, setActiveService] = useState('investment');

  const services = {
    investment: {
      title: '投资估算',
      fullTitle: '投资估算咨询、编制及审核服务',
      icon: <FiBarChart />,
      tagline: '为项目立项和投资决策提供数据支撑',
      whatWeDo: '在项目建议书、可行性研究阶段，我们根据建设规模、标准和市场行情，编制投资估算报告，帮助您科学决策、控制风险。',
      coreValue: [
        '快速测算：3-5个工作日出具投资估算报告',
        '数据对标：对接50万+项目数据库，提供同类项目参考',
        '风险预判：提供投资回报测算和敏感性分析'
      ],
      suitable: '政府立项、央企投资决策、社会资本可研论证',
      deliverable: '投资估算书、经济评价报告、投资回报模型'
    },
    design: {
      title: '设计概算',
      fullTitle: '设计概算咨询、编制及审核服务',
      icon: <FiTarget />,
      tagline: '设计阶段控制投资，避免后期超概',
      whatWeDo: '在初步设计完成后，我们按照设计图纸和技术方案编制概算，并提供限额设计咨询，确保设计不突破投资限额。',
      coreValue: [
        '限额设计：指导设计优化，防止概算超估算',
        '方案比选：提供多方案经济性分析，择优推荐',
        '快速审核：7个工作日内完成概算审核并出具意见'
      ],
      suitable: '大型公建、基础设施、工业项目设计阶段',
      deliverable: '设计概算书、限额设计控制指标、概算审核报告'
    },
    budget: {
      title: '工程预算',
      fullTitle: '工程预算咨询、编制及审核服务',
      icon: <FiFileText />,
      tagline: '施工图阶段精准算量，为招投标提供依据',
      whatWeDo: '根据施工图纸和现行定额，编制详细的工程预算和工程量清单，为编制招标控制价、投标报价提供准确依据。',
      coreValue: [
        'AI算量：图纸识别+智能算量，效率提升85%',
        '精准复核：工程量误差率控制在1%以内',
        '清单优化：规避清单漏项、错项等常见问题'
      ],
      suitable: '招标控制价编制、施工单位投标报价、预算审核',
      deliverable: '施工图预算书、工程量清单、招标控制价文件'
    },
    settlement: {
      title: '工程结算',
      fullTitle: '工程结算咨询、编制及审核服务',
      icon: <FiCheckCircle />,
      tagline: 'AI+专家双审，平均审减率15%-25%',
      whatWeDo: '竣工后根据合同、图纸、变更签证等资料编制或审核结算，采用AI智能识别+造价师复核模式，精准发现多算、高套、重复计费等问题。',
      coreValue: [
        'AI预审：自动识别异常项，准确率98.6%',
        '深度复核：注册造价师逐项核对，出具审减清单',
        '争议调解：提供专业意见，协助双方达成一致'
      ],
      suitable: '业主方结算审核、施工方结算编制、审计配合',
      deliverable: '结算审核报告、审减明细表、问题整改清单'
    },
    other: {
      title: '工程其他费',
      fullTitle: '工程其他费咨询、编制及审核服务',
      icon: <RmbIcon size={44} />,
      tagline: '全口径费用管控，避免遗漏超标',
      whatWeDo: '针对建设管理费、前期咨询费、监理费、招标代理费、专项评估费等其他费用，提供测算、审核和优化服务，形成全口径投资清单。',
      coreValue: [
        '全口径梳理：涵盖30+项其他费用科目',
        '合规审核：确保费用标准符合国家和地方规定',
        '成本优化：识别并减少不合理费用支出'
      ],
      suitable: '政府投资项目、央企集团投资管理、审计配合',
      deliverable: '其他费用清单、费用审核报告、优化建议'
    },
    final: {
      title: '项目决算',
      fullTitle: '项目决算咨询、编制及审核服务',
      icon: <FiTrendingUp />,
      tagline: '竣工决算编制与审核，为后续项目积累数据',
      whatWeDo: '在项目竣工验收后，根据财务资料和竣工结算，编制竣工财务决算，分析投资偏差原因，形成造价指标库，为同类项目提供参考。',
      coreValue: [
        '偏差分析：对比估算、概算、预算、决算，找出偏差根因',
        '指标沉淀：建立企业/行业造价指标数据库',
        '审计支持：满足审计署、财政审计要求'
      ],
      suitable: '竣工验收后决算编制、集团投资复盘、审计配合',
      deliverable: '竣工财务决算书、投资偏差分析报告、造价指标'
    },
    tendering: {
      title: '招投标代理',
      fullTitle: '招投标代理服务、政府采购代理服务',
      icon: <FiClipboard />,
      tagline: '全流程合规组织，电子化留痕可追溯',
      whatWeDo: '提供招标文件编制、公告发布、开评标组织、政府采购代理等服务，确保招投标过程公开透明、合法合规，全程电子化留痕。',
      coreValue: [
        '合规保障：招标投标法、政府采购法全程合规',
        '电子化平台：线上招投标，过程100%留痕可追溯',
        '高效组织：平均15个工作日完成招标全流程'
      ],
      suitable: '政府投资项目、央国企集采、PPP项目招标',
      deliverable: '招标文件、评标报告、中标通知书、全程留痕资料'
    },
    procurement: {
      title: '采购代理',
      fullTitle: '采购业务代理服务',
      icon: <FiShield />,
      tagline: '材料设备采购专业支持，降本增效',
      whatWeDo: '针对大宗材料、机电设备等采购需求，提供市场询价、供应商评估、商务谈判、合同管理、履约监督等服务，帮助您优化采购成本。',
      coreValue: [
        '市场询价：对接全国供应商网络，提供最优报价',
        '降本增效：通过集采和谈判，平均降低采购成本8-15%',
        '质量把控：供应商资质审查+履约过程监督'
      ],
      suitable: '材料设备集中采购、专业分包采购、供应链管理',
      deliverable: '采购策略方案、市场询价报告、采购合同、履约报告'
    }
  };

  const tabList = [
    { key: 'investment', label: '投资估算', icon: <FiBarChart /> },
    { key: 'design', label: '设计概算', icon: <FiTarget /> },
    { key: 'budget', label: '工程预算', icon: <FiFileText /> },
    { key: 'settlement', label: '工程结算', icon: <FiCheckCircle /> },
    { key: 'other', label: '工程其他费', icon: <RmbIcon size={28} /> },
    { key: 'final', label: '项目决算', icon: <FiTrendingUp /> },
    { key: 'tendering', label: '招投标代理', icon: <FiClipboard /> },
    { key: 'procurement', label: '采购代理', icon: <FiShield /> }
  ];

  const current = services[activeService];

  return (
    <section className="services-section">
      <div className="container">
        <h2 className="section-title">八大专业服务</h2>
        <p className="section-subtitle">
          涵盖工程项目全生命周期的造价咨询、审核、招标、采购等专业服务
        </p>

        <div className="services-tabs-home">
          {tabList.map((tab) => (
            <button
              key={tab.key}
              className={`service-tab ${activeService === tab.key ? 'active' : ''}`}
              onClick={() => setActiveService(tab.key)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="service-showcase">
          <div className="showcase-header">
            <div className="showcase-icon">{current.icon}</div>
            <div>
              <h3>{current.fullTitle}</h3>
              <p className="tagline">{current.tagline}</p>
            </div>
          </div>

          <div className="showcase-body">
            <div className="showcase-intro">
              <h4>我们做什么？</h4>
              <p>{current.whatWeDo}</p>
            </div>

            <div className="showcase-values">
              <h4>核心价值</h4>
              <ul>
                {current.coreValue.map((value, index) => (
                  <li key={index}>
                    <FiCheckCircle />
                    <span>{value}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="showcase-meta">
              <div className="meta-item">
                <span className="meta-label">适用场景</span>
                <span className="meta-value">{current.suitable}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">交付成果</span>
                <span className="meta-value">{current.deliverable}</span>
              </div>
            </div>

            <div className="showcase-actions">
              <Link to={`/services#${activeService}`} className="btn btn-primary">
                查看详细服务 <FiArrowRight />
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                立即咨询
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
